var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"header",attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../../assets/logo-color.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }